<template>
  <v-badge v-if="notices.length" :content="notices.length" color="error" overlap>
    <v-btn icon :aria-label="$t('ConditionalReturn.NotificationHeading')" @click="$store.state.showNotification = !$store.state.showNotification">
      <v-icon size="23">
        {{ bellIcon }}
      </v-icon>
    </v-btn>
  </v-badge>
</template>

<script>
import { mdiBellOutline } from '@mdi/js'

export default {
  data: () => ({ bellIcon: mdiBellOutline }),
  computed: {
    notices() { return this.$store.state.notifications.conditional_return_notifications || [] },
  },
}
</script>
